import { combineReducers } from "redux";
import loaderReducer from "./common/loaderReducer";
import globalsReducer from "./common/globalsReducer";
import userReducer from "./user/userReducer";
import jobPostingReducer from "./jobPosting/jobPostingReducer";
import jobReducer from "./job/jobReducer";

const rootReducer = combineReducers({
  loader: loaderReducer,
  user: userReducer,
  global: globalsReducer,
  jobPosting: jobPostingReducer,
  job: jobReducer,
});

export default rootReducer;
